import { IsTreatmentFromAiOptionModel } from '../../model';

export const IsTreatmentFromAiOptions = Object.freeze<IsTreatmentFromAiOptionModel[]>([
    { value: true, label: '是' },
    { value: false, label: '否' },
    // { value: null, label: '清除' },
]);
